<ion-footer>
  <ion-toolbar>
    <ul>
      <!--      <div class="active-indicator" #activeIndicator></div>-->
      <ng-container *ngFor="let menu_item_footer1 of menuService.menuItemsFooter1$|async; let i = index">
        <li class="{{menu_item_footer1._id}}"
            (click)="menuService.openPage(menu_item_footer1)"><span
          *ngIf="menu_item_footer1?.count && menu_item_footer1.count != 0 "
          class="counter">{{ menu_item_footer1.count }}</span>
          <ng-container *ngIf="menu_item_footer1.src_img&& menu_item_footer1.src_img!=='';else icn">
            <img class="{{menu_item_footer1._id}}" src="{{menu_item_footer1.src_img}}" [alt]="menu_item_footer1._id">
          </ng-container>
          <ng-template #icn>
            <ion-icon *ngIf=" menu_item_footer1.icon!='';else notIoniconIcon" name="{{menu_item_footer1.icon}}"
                      class="ion-padding-horizontal"></ion-icon>
            <ng-template #notIoniconIcon>
              <ion-icon [src]="'assets/icon/'+ menu_item_footer1._id + '.svg'"
                        class="ion-padding-horizontal rotate"></ion-icon>
            </ng-template>
          </ng-template>
          <ion-text>{{menu_item_footer1.title|footerTrunc}}</ion-text>
        </li>
      </ng-container>
      <ng-container *ngFor="let menu_item_footer2 of menuService.menuItemsFooter2$|async; let i = index">
        <li (click)="menuService.openPage(menu_item_footer2)" [ngClass]="{'search-width': i == 3, 'search': i == 3}"
            [class]="menu_item_footer2._id">
          <ion-icon *ngIf="menu_item_footer2.icon;else img2" name="{{menu_item_footer2.icon}}"></ion-icon>
          <span *ngIf="(auth.isLogin$|async) && menu_item_footer2?.count && menu_item_footer2.count != 0"
                class="counter">{{ menu_item_footer2.count }}</span>
          <ng-template #img2>
            <img [class]="menu_item_footer2._id" [src]="menu_item_footer2.src_img"
                 [alt]="menu_item_footer2._id"></ng-template>
          <ion-text>{{menu_item_footer2.title|footerTrunc}}</ion-text>
        </li>
      </ng-container>
    </ul>
  </ion-toolbar>
</ion-footer>
